import { render, staticRenderFns } from "./PageDataTable.vue?vue&type=template&id=1939cfe8&scoped=true&"
import script from "./PageDataTable.vue?vue&type=script&lang=js&"
export * from "./PageDataTable.vue?vue&type=script&lang=js&"
import style0 from "./PageDataTable.vue?vue&type=style&index=0&id=1939cfe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1939cfe8",
  null
  
)

export default component.exports